// Module
var code = `<div class="news-panel">
    <div class="news-panel-container-top">
        <terceraLabel  visible={{true}} text="Feed" name="feedsLabel"/>
        <terceraComboBox visible={{true}} name="feedsComboBox" on-ValueChange="onSelectedFeedChange"/>
        <rangeSelectPanel name='newsPanelRangeSelect' />
    </div>
    <div class="news-panel-container-table">
        <terceraPanel name="windowPanelBodyQT" />

        {{#if noData}}
            {{>noDataPart}}
        {{/if}}
    </div>
</div>
`;
// Exports
export default code;